import { Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { useTranslation } from "react-i18next";
import CopyTaskIdButton from "@/components/backgroundTasks/copyTaskIdButton";
import TaskCompanyList from "@/components/backgroundTasks/taskCompanyList";
import cardStyles from "@/components/summaryCard/summaryCard.module.css";
import styles from "@/components/backgroundTasks/batchDocumentTaskResult.module.css";

export interface BatchDocumentTaskData {
  target?: { kwargs?: { template_name?: string } };
  result?: { companies?: string[]; status?: string } | null;
}

interface Props {
  taskId: string;
  task?: BatchDocumentTaskData | null;
}

export default function BatchDocumentTaskResult({ taskId, task }: Props) {
  const { t } = useTranslation();
  const templateName = task?.target?.kwargs?.template_name || "-";
  const statusMessage = task?.result?.status;

  return (
    <section className={cardStyles.card}>
      <div className={cardStyles.header}>
        <span className={cardStyles.iconContainer} aria-hidden="true">
          <DescriptionOutlinedIcon />
        </span>
        <div className={cardStyles.headerCopy}>
          <Typography className={cardStyles.headerLabel}>
            {t("document_template")}
          </Typography>
          <Typography className={cardStyles.headerValue}>
            {templateName}
          </Typography>
        </div>
        <CopyTaskIdButton taskId={taskId} />
      </div>

      {statusMessage && (
        <div className={styles.statusMessage}>
          <CheckCircleOutlineIcon
            className={styles.statusIcon}
            aria-hidden="true"
          />
          <Typography className={styles.statusText}>{statusMessage}</Typography>
        </div>
      )}

      <TaskCompanyList companies={task?.result?.companies ?? []} />
    </section>
  );
}
